import React from "react";
import { cx } from "components/crm/ui/uiUtils";

const base =
  "inline-flex items-center justify-center gap-2 rounded-lg border font-semibold whitespace-nowrap transition duration-150 active:scale-[0.97] disabled:cursor-not-allowed disabled:active:scale-100";
const sizes = {
  sm: "px-4 py-[10px] text-sm leading-[18px]",
  md: "p-4 text-base leading-5 tracking-[-0.31px]",
};
const variants = {
  primary:
    "bg-primary border-primary text-white hover:bg-[#f08c00] active:bg-primary-dark disabled:bg-surfaceMuted disabled:border-surfaceMuted disabled:text-faint",
  secondary:
    "bg-white border-line text-[#1f2937] hover:border-lineStrong hover:bg-gray-50 active:bg-gray-100 disabled:text-faint",
  ghost:
    "bg-transparent border-transparent text-[#1f2937] hover:bg-surfaceMuted active:bg-lineStrong",
};

// With `href`, a link drawn as the button (a tel: link, for instance).
const Button = ({
  variant = "primary",
  size = "sm",
  icon: Icon,
  children,
  className,
  href,
  ...props
}) => {
  const classes = cx(base, sizes[size], variants[variant], className);
  const content = (
    <>
      {Icon && <Icon size={size === "md" ? 20 : 18} strokeWidth={2} />}
      {children}
    </>
  );
  if (href)
    return (
      <a href={href} className={classes} {...props}>
        {content}
      </a>
    );
  return (
    <button type="button" className={classes} {...props}>
      {content}
    </button>
  );
};

export default Button;
